var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "error_403"
  }, [_c('div', {
    staticClass: "container-scroller"
  }, [_c('div', {
    staticClass: "container-fluid page-body-wrapper full-page-wrapper"
  }, [_c('div', {
    staticClass: "\n          content-wrapper\n          d-flex\n          align-items-center\n          text-center\n          error-page\n        "
  }, [_c('div', {
    staticClass: "row flex-grow"
  }, [_c('div', {
    staticClass: "col-lg-8 mx-auto"
  }, [_c('div', {
    staticClass: "row align-items-center d-flex flex-row"
  }, [_c('div', {
    staticClass: "error-page-divider text-lg-left pl-lg-4"
  }, [_c('h3', {
    staticClass: "font-weight-light"
  }, [_vm._v(" 很抱歉，您目前未有訪問權限 ")])])])])])])])])]);
}]

export { render, staticRenderFns }